"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import Managerment from "@/views/managements/Managerment.vue";
import MenuItem from "@/components/menu/MenuItem.vue";
import MainView from "@/components/layout/MainView.vue";
import TeamLoginController from "@/views/managements/safemanager/components/TeamLoginController.vue";
import RequestController from "@/views/managements/safemanager/components/RequestController.vue";
import PassRequestController from "@/views/managements/safemanager/components/PassRequestController.vue";
import RefuseRequestController from "@/views/managements/safemanager/components/RefuseRequestController.vue";
import BlackListRequestController from "@/views/managements/safemanager/components/BlackListRequestController.vue";
import VisitorController from "@/views/managements/safemanager/components/VisitorController.vue";
import AccountSecurityAccess from "@/views/managements/safemanager/components/AccountSecurityAccess.vue";
import DataSafety from "@/views/managements/safemanager/components/DataSecurityController.vue";
import AccessRules from "@/views/managements/safemanager/components/AccessRulesController.vue";
import WebResources from "@/views/managements/safemanager/components/WebResourcesController.vue";
import WebResourceRequestList from "./components/WebResourceRequestList.vue";
import TeamAccessController from "./components/TeamAccessController.vue";
import _ from "lodash";
import i18n from "@/lang";
const UUID = require("uuid");
import UiMenuBar, {
  MenuController
} from "@/components/menu/ManagerMenuBar.vue";
let SafeManager = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.menu_controller = new MenuController(
      false,
      [
        {
          index: "TeamLoginController",
          icon_image: "safety_sidebar_1",
          name: i18n.t("safe_management.team_login_sidebar")
        },
        {
          index: "TeamLoginRequest",
          icon_image: "safety_sidebar_2",
          name: i18n.t("safe_management.team_login_request_sidebar"),
          sub_menus: [
            {
              index: "request",
              name: i18n.t("safe_management.team_wait_sidebar")
            },
            {
              index: "pass",
              name: i18n.t("safe_management.team_pass_sidebar")
            },
            {
              index: "refuse",
              name: i18n.t("safe_management.team_refuse_sidebar")
            },
            {
              index: "blacklist",
              name: i18n.t("safe_management.team_blacklist_sidebar")
            }
          ]
        },
        // {
        //   index: "Accesscontroller",
        //   icon_image: "safety_sidebar_3",
        //   name: i18n.t("safe_management.access_control_sidebar") as string,
        // },
        {
          index: "AccountSafety",
          icon_image: "safety_sidebar_4",
          name: i18n.t("safe_management.account_safety_sidebar")
        },
        {
          index: "DataSafety",
          icon_image: "safety_sidebar_5",
          name: i18n.t("safe_management.data_safety")
        }
        // {
        //   index: "MemberAccessControll",
        //   icon_image: "safety_sidebar_6",
        //   name: i18n.t("safe_management.mumber_request") as string,
        //   sub_menus: [
        //     {
        //       index: "access_rule",
        //       name: i18n.t("safe_management.access_rule") as string,
        //     },
        //     {
        //       index: "web_resource_request_list",
        //       name:i18n.t("safe_management.request_list") as string,
        //     },
        //     {
        //       index: "web_resource",
        //       name: i18n.t("safe_management.web_resource") as string,
        //     },
        //   ],
        // },
      ],
      "TeamLoginController",
      ["TeamLoginRequest"]
    );
    this.default_components = "";
    this.mumber_autid_key = "";
  }
  created() {
    return __async(this, null, function* () {
      this.default_components = "TeamLoginController";
      if (this.$session.type === "user") {
        this.menu_controller = new MenuController(
          false,
          [
            {
              index: "TeamLoginController",
              icon_image: "safety_sidebar_1",
              name: i18n.t("safe_management.team_login_sidebar")
            },
            {
              index: "TeamLoginRequest",
              icon_image: "safety_sidebar_2",
              name: i18n.t(
                "safe_management.team_login_request_sidebar"
              ),
              sub_menus: [
                {
                  index: "request",
                  name: i18n.t("safe_management.team_wait_sidebar")
                },
                {
                  index: "pass",
                  name: i18n.t("safe_management.team_pass_sidebar")
                },
                {
                  index: "refuse",
                  name: i18n.t("safe_management.team_refuse_sidebar")
                },
                {
                  index: "blacklist",
                  name: i18n.t(
                    "safe_management.team_blacklist_sidebar"
                  )
                }
              ]
            }
            // {
            //   index: "Accesscontroller",
            //   icon_image: "safety_sidebar_3",
            //   name: i18n.t("safe_management.access_control_sidebar") as string,
            // },
          ],
          "TeamLoginController",
          ["TeamLoginRequest"]
        );
      }
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.checkVersion();
      if (this.$route.query.hasOwnProperty("tab")) {
        let _hash = this.$route.query.tab;
        let _index = _.find(this.menu_controller.menu_lists, { index: _hash });
        if (!_index) {
          for (let item of this.menu_controller.menu_lists) {
            if (item.hasOwnProperty("sub_menus")) {
              _index = _.find(item.sub_menus, { index: _hash });
              if (_index !== void 0) {
                break;
              }
            }
          }
        }
        if (_index !== void 0) {
          this.menu_controller.default_components = _index.index;
          this.default_components = _index.index;
        }
      }
    });
  }
  checkVersion() {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        if (this.$session.type === "user") {
          let arr = [
            {
              index: "TeamLoginController",
              icon_image: "safety_sidebar_1",
              name: i18n.t("safe_management.team_login_sidebar")
            },
            {
              index: "TeamLoginRequest",
              icon_image: "safety_sidebar_2",
              name: i18n.t(
                "safe_management.team_login_request_sidebar"
              ),
              sub_menus: [
                {
                  index: "request",
                  name: i18n.t("safe_management.team_wait_sidebar")
                },
                {
                  index: "pass",
                  name: i18n.t("safe_management.team_pass_sidebar")
                },
                {
                  index: "refuse",
                  name: i18n.t(
                    "safe_management.team_refuse_sidebar"
                  )
                },
                {
                  index: "blacklist",
                  name: i18n.t(
                    "safe_management.team_blacklist_sidebar"
                  )
                }
              ]
            }
          ];
          if ((_a = this.$session) == null ? void 0 : _a.marks.is("SHOW_WHITELIST")) {
            arr = [
              {
                index: "TeamLoginController",
                icon_image: "safety_sidebar_1",
                name: i18n.t("safe_management.team_login_sidebar")
              },
              {
                index: "TeamLoginRequest",
                icon_image: "safety_sidebar_2",
                name: i18n.t(
                  "safe_management.team_login_request_sidebar"
                ),
                sub_menus: [
                  {
                    index: "request",
                    name: i18n.t("safe_management.team_wait_sidebar")
                  },
                  {
                    index: "pass",
                    name: i18n.t("safe_management.team_pass_sidebar")
                  },
                  {
                    index: "refuse",
                    name: i18n.t(
                      "safe_management.team_refuse_sidebar"
                    )
                  },
                  {
                    index: "blacklist",
                    name: i18n.t(
                      "safe_management.team_blacklist_sidebar"
                    )
                  }
                ]
              },
              {
                index: "Accesscontroller",
                icon_image: "safety_sidebar_3",
                name: i18n.t(
                  "safe_management.access_control_sidebar"
                )
              }
            ];
          }
          this.menu_controller = new MenuController(
            false,
            arr,
            "TeamLoginController",
            ["TeamLoginRequest"]
          );
        }
        if (this.$session.type === "account") {
          let arr = [
            {
              index: "TeamLoginController",
              icon_image: "safety_sidebar_1",
              name: i18n.t("safe_management.team_login_sidebar")
            },
            {
              index: "TeamLoginRequest",
              icon_image: "safety_sidebar_2",
              name: i18n.t(
                "safe_management.team_login_request_sidebar"
              ),
              sub_menus: [
                {
                  index: "request",
                  name: i18n.t("safe_management.team_wait_sidebar")
                },
                {
                  index: "pass",
                  name: i18n.t("safe_management.team_pass_sidebar")
                },
                {
                  index: "refuse",
                  name: i18n.t(
                    "safe_management.team_refuse_sidebar"
                  )
                },
                {
                  index: "blacklist",
                  name: i18n.t(
                    "safe_management.team_blacklist_sidebar"
                  )
                }
              ]
            },
            {
              index: "AccountSafety",
              icon_image: "safety_sidebar_4",
              name: i18n.t(
                "safe_management.account_safety_sidebar"
              )
            },
            {
              index: "DataSafety",
              icon_image: "safety_sidebar_5",
              name: i18n.t("safe_management.data_safety")
            },
            {
              index: "MemberAccessControll",
              icon_image: "safety_sidebar_6",
              name: i18n.t("safe_management.mumber_request"),
              sub_menus: [
                {
                  index: "access_rule",
                  name: i18n.t("safe_management.access_rule")
                },
                {
                  index: "web_resource_request_list",
                  name: i18n.t("safe_management.request_list")
                },
                {
                  index: "web_resource",
                  name: i18n.t("safe_management.web_resource")
                }
              ]
            }
          ];
          if ((_b = this.$session) == null ? void 0 : _b.marks.is("SHOW_WHITELIST")) {
            arr = [
              {
                index: "TeamLoginController",
                icon_image: "safety_sidebar_1",
                name: i18n.t("safe_management.team_login_sidebar")
              },
              {
                index: "TeamLoginRequest",
                icon_image: "safety_sidebar_2",
                name: i18n.t(
                  "safe_management.team_login_request_sidebar"
                ),
                sub_menus: [
                  {
                    index: "request",
                    name: i18n.t("safe_management.team_wait_sidebar")
                  },
                  {
                    index: "pass",
                    name: i18n.t("safe_management.team_pass_sidebar")
                  },
                  {
                    index: "refuse",
                    name: i18n.t(
                      "safe_management.team_refuse_sidebar"
                    )
                  },
                  {
                    index: "blacklist",
                    name: i18n.t(
                      "safe_management.team_blacklist_sidebar"
                    )
                  }
                ]
              },
              {
                index: "Accesscontroller",
                icon_image: "safety_sidebar_3",
                name: i18n.t(
                  "safe_management.access_control_sidebar"
                )
              },
              {
                index: "AccountSafety",
                icon_image: "safety_sidebar_4",
                name: i18n.t(
                  "safe_management.account_safety_sidebar"
                )
              },
              {
                index: "DataSafety",
                icon_image: "safety_sidebar_5",
                name: i18n.t("safe_management.data_safety")
              },
              {
                index: "MemberAccessControll",
                icon_image: "safety_sidebar_6",
                name: i18n.t("safe_management.mumber_request"),
                sub_menus: [
                  {
                    index: "access_rule",
                    name: i18n.t("safe_management.access_rule")
                  },
                  {
                    index: "web_resource_request_list",
                    name: i18n.t("safe_management.request_list")
                  },
                  {
                    index: "web_resource",
                    name: i18n.t("safe_management.web_resource")
                  }
                ]
              }
            ];
          }
          this.menu_controller = new MenuController(
            false,
            arr,
            "TeamLoginController",
            ["TeamLoginRequest"]
          );
        }
      } catch (error) {
      }
    });
  }
  changeCollapse() {
    this.mumber_autid_key = UUID.v4();
  }
  changeTeamComponent(data) {
    console.log(data);
    if (data) {
      this.default_components = data;
    }
  }
};
SafeManager = __decorateClass([
  Component({
    components: {
      Managerment,
      MenuItem,
      MainView,
      TeamLoginController,
      RequestController,
      PassRequestController,
      RefuseRequestController,
      BlackListRequestController,
      VisitorController,
      UiMenuBar,
      AccountSecurityAccess,
      DataSafety,
      AccessRules,
      WebResources,
      TeamAccessController,
      WebResourceRequestList
    }
  })
], SafeManager);
export {
  SafeManager as default
};
